"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('./chunk-V422Z6ZH.js');
var chunkUUN3IUQ2_js = require('./chunk-UUN3IUQ2.js');
var chunk356JBGIO_js = require('./chunk-356JBGIO.js');
var chunkVYE5YPCD_js = require('./chunk-VYE5YPCD.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var react = require('react');
var T = require('styled-components');
var faUpload = require('@fortawesome/pro-solid-svg-icons/faUpload');
var faTriangleExclamation = require('@fortawesome/pro-solid-svg-icons/faTriangleExclamation');
var faArrowUp = require('@fortawesome/pro-solid-svg-icons/faArrowUp');
var faHexagonExclamation = require('@fortawesome/pro-solid-svg-icons/faHexagonExclamation');
var faDownload = require('@fortawesome/pro-solid-svg-icons/faDownload');
var faTrashCan = require('@fortawesome/pro-solid-svg-icons/faTrashCan');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var T__default = /*#__PURE__*/_interopDefaultLegacy(T);

var h=T__default["default"].button`
  width: 100%;
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-small);
  cursor: pointer;
  // focus in this case changes background and border color no need for outline
  outline: none;

  // applies to idle or loading by default
  background: var(--foreground-inverse);
  border: 1px solid var(--color-blue-700);

  ${e=>e.status!=="showing_files"&&`    
      &:hover,
      &:focus {
        background: var(--color-blue-100);
      }
    `}

  ${e=>e.status==="warning"&&`
    background: var(--background-warning);
    border: 1px dashed var(--border-warning);

    &:hover,
    &:focus {
      background: var(--background-warning);
      border: 1px dashed var(--border-warning);
    }
  `}

  ${e=>e.status==="error"&&`
    background: var(--background-error-base);
    border: 1px dashed var(--border-error);

    &:hover,
    &:focus {
      background: var(--background-error-base);
      border: 1px dashed var(--border-error);
    }
  `}

  ${e=>e.status==="focus"&&`
    background: var(--color-blue-100);

    > * {
      pointer-events: none;
    }
  `}

  > input {
    height: 0;
    visibility: hidden;
    width: 0;
    position: absolute;
  }
`,U=T__default["default"].span`
  text-decoration: underline;
  color: var(--color-blue-700);
`,F=T__default["default"].div`
  display: flex;
  align-items: center;
  justify-content: center;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  svg:first-child {
    animation: rotate 1s linear infinite;
    transform-origin: center;
  }

  ${chunkLXX3SSRV_js.b} {
    position: absolute;
  }
`,L=T__default["default"](chunkVYE5YPCD_js.a)`
  padding: 0;

  &:hover:not(:active):not([disabled]),
  &:focus:not(:active):not([disabled]) {
    background: transparent;
  }
`;function I(e,t){let n=t.split(",");if(n.length<=0)return !0;let c=e.name||"",w=(e.type||"").toLowerCase(),v=w.replace(/\/.*$/,"");return n.some(b=>{let d=b.trim().toLowerCase();return d.charAt(0)==="."?c.toLowerCase().endsWith(d):d.endsWith("/*")?v===d.replace(/\/.*$/,""):w===d})}var _={status:"idle"};function M(e,t){switch(t.type){case"RESET_STATUS":case"DRAG_LEAVE":return {status:"idle"};case"DRAG_OVER":return {status:"focus"};case"START_UPLOAD":return {status:"uploading"};case"CLEAN_LIST":return {status:"idle"};case"UPLOAD_FINISHED":return {status:"showing_files",files:t.files};case"UPLOAD_ERROR":return {status:"error",errorMessage:t.errorMessage};case"INVALIDATE_FILES":return {status:"warning",warningMessage:t.warningMessage};default:return e}}var O=T__default["default"](chunkUUN3IUQ2_js.a)`
  // hack for ellipsis within flexbox
  // ref: https://css-tricks.com/flexbox-truncated-text/
  min-width: 0;
`,H=T__default["default"].div`
  min-width: 0;
  text-align: left;

  ${chunk2VCHSK65_js.d} {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`,N=T__default["default"].div`
  // hack to make sure icon follows the size required
  // regardless of ellipsis cut
  > svg {
    min-width: var(--icon-size-x-large);
    min-height: var(--icon-size-x-large);
    max-width: var(--icon-size-x-large);
    max-height: var(--icon-size-x-large);
  }
`;var X=e=>()=>{let t=new Blob([e.html],{type:"image/svg+xml"}),n=URL.createObjectURL(t),c=Object.assign(document.createElement("a"),{href:n,download:e.name,target:"_blank",style:{visibility:"hidden"}});document.body.append(c),c.click(),c.remove();},G=({files:e,actions:t})=>jsxRuntime.jsx(jsxRuntime.Fragment,{children:e.map(n=>jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{spacing:"small",yAlign:"center",xAlign:"space-between",children:[jsxRuntime.jsxs(O,{spacing:"small",yAlign:"center",children:[jsxRuntime.jsx(N,{dangerouslySetInnerHTML:{__html:n.html}}),jsxRuntime.jsx(H,{children:jsxRuntime.jsx(chunk2VCHSK65_js.d,{weight:"bold",colorToken:"foreground-primary",children:n.name})})]}),jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{spacing:"small",yAlign:"center","aria-label":"download image",children:[jsxRuntime.jsx(chunkVYE5YPCD_js.a,{variant:"tertiary",iconOnly:!0,onClick:X(n),children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faDownload.faDownload,colorToken:"foreground-primary"})}),jsxRuntime.jsx(chunkVYE5YPCD_js.a,{variant:"tertiary",iconOnly:!0,onClick:t.handleCleanList,"aria-label":"remove image",children:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faTrashCan.faTrashCan,colorToken:"background-button-destructive-default"})})]})]},n.name))});var V=({onUpload:e,multiple:t=!1,accept:n="",maxSize:c,description:w,renderList:v,onListEmpty:b,initialList:d,...W})=>{let $=react.useMemo(()=>`sonar-upload-box-${crypto.randomUUID()}`,[]),R=react.useRef(null),[a,u]=react.useReducer(M,d?{status:"showing_files",files:d}:_),C=o=>{let g=[...o],y=[];return !t&&g.length>1&&y.push("You must select a single file."),g.some(A=>!I(A,n))&&y.push("File format not supported."),c&&g.some(A=>A.size>c*1e3)&&y.push(`File too large: Limit is ${c}KB`),y.length>0?(u({type:"INVALIDATE_FILES",warningMessage:y[0]}),!1):!0},E=async o=>{u({type:"START_UPLOAD"});try{let g=await e(o);u({type:"UPLOAD_FINISHED",files:g});}catch(g){g instanceof Error&&u({type:"UPLOAD_ERROR",errorMessage:g.message});}},z=o=>{o.preventDefault(),C(o.dataTransfer.files)&&E(o.dataTransfer.files);},Z=o=>{o.preventDefault(),u({type:"DRAG_OVER"});},j=o=>{o.preventDefault(),u({type:"DRAG_LEAVE"});},q=o=>{!o.target.files||!C(o.target.files)||E(o.target.files);},K=()=>{var o;(o=R.current)==null||o.click();},Y=()=>{u({type:"CLEAN_LIST"}),b();},D=()=>{u({type:"RESET_STATUS"});};return a.status==="showing_files"?jsxRuntime.jsx(h,{status:a.status,as:"div",children:v(a.files,{handleCleanList:Y})}):a.status==="error"?jsxRuntime.jsx(h,{status:a.status,as:"div",children:jsxRuntime.jsxs(chunk356JBGIO_js.a,{spacing:"small",xAlign:"center",children:[jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{spacing:"small",yAlign:"center",children:[jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faHexagonExclamation.faHexagonExclamation,colorToken:"foreground-error"}),jsxRuntime.jsx(chunk2VCHSK65_js.d,{weight:"bold",colorToken:"foreground-error",children:a.errorMessage})]}),jsxRuntime.jsx(L,{variant:"tertiary",onClick:D,children:"Back"})]})}):a.status==="warning"?jsxRuntime.jsx(h,{status:a.status,as:"div",children:jsxRuntime.jsxs(chunk356JBGIO_js.a,{spacing:"small",xAlign:"center",children:[jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{spacing:"small",yAlign:"center",children:[jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faTriangleExclamation.faTriangleExclamation,colorToken:"foreground-warning"}),jsxRuntime.jsx(chunk2VCHSK65_js.d,{weight:"bold",colorToken:"foreground-warning",children:a.warningMessage})]}),jsxRuntime.jsx(L,{variant:"tertiary",onClick:D,children:"Back"})]})}):a.status==="uploading"?jsxRuntime.jsx(h,{status:a.status,as:"div",children:jsxRuntime.jsxs(chunk356JBGIO_js.a,{spacing:"small",xAlign:"center",children:[jsxRuntime.jsxs(F,{children:[jsxRuntime.jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",children:[jsxRuntime.jsx("path",{d:"M24 12C24 14.5342 23.1977 17.0033 21.7082 19.0534C20.2187 21.1036 18.1183 22.6296 15.7082 23.4127C13.2981 24.1958 10.7019 24.1958 8.2918 23.4127C5.88167 22.6296 3.78133 21.1036 2.2918 19.0534C0.802259 17.0033 -2.21542e-07 14.5342 0 12C2.21543e-07 9.46585 0.80226 6.99675 2.2918 4.94658C3.78133 2.8964 5.88168 1.37042 8.2918 0.587321C10.7019 -0.195774 13.2981 -0.195774 15.7082 0.587322L15.1149 2.41335C13.0904 1.75555 10.9096 1.75555 8.88511 2.41335C6.86061 3.07115 5.09632 4.35298 3.84511 6.07512C2.5939 7.79727 1.92 9.87131 1.92 12C1.92 14.1287 2.5939 16.2027 3.84511 17.9249C5.09632 19.647 6.86061 20.9288 8.88511 21.5866C10.9096 22.2444 13.0904 22.2445 15.1149 21.5866C17.1394 20.9288 18.9037 19.647 20.1549 17.9249C21.4061 16.2027 22.08 14.1287 22.08 12H24Z",fill:"#DCE4F2",id:"circlePath"}),jsxRuntime.jsx("path",{id:"movingPath",d:"M12 0C13.5759 1.8792e-08 15.1363 0.310389 16.5922 0.913446C18.0481 1.5165 19.371 2.40042 20.4853 3.51472C21.5996 4.62902 22.4835 5.95189 23.0866 7.4078C23.6896 8.86371 24 10.4241 24 12L22.08 12C22.08 10.6763 21.8193 9.36551 21.3127 8.14255C20.8061 6.91959 20.0637 5.80838 19.1276 4.87236C18.1916 3.93635 17.0804 3.19386 15.8574 2.68729C14.6345 2.18073 13.3237 1.92 12 1.92L12 0Z",fill:"#0056A1"})]}),jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faArrowUp.faArrowUp,colorToken:"foreground-primary",size:"x-small"})]}),jsxRuntime.jsx(chunk2VCHSK65_js.d,{weight:"bold",colorToken:"foreground-primary",children:"Uploading file..."})]})}):jsxRuntime.jsxs(h,{...W,status:a.status,onDrop:z,onDragOver:Z,onDragLeave:j,onClick:K,type:"button",children:[jsxRuntime.jsx("input",{type:"file",id:$,"aria-hidden":!0,onChange:q,multiple:t,accept:n,ref:R}),jsxRuntime.jsxs(chunk356JBGIO_js.a,{spacing:"small",xAlign:"center",children:[jsxRuntime.jsxs(chunkUUN3IUQ2_js.a,{spacing:"small",yAlign:"center",children:[jsxRuntime.jsx(chunkLXX3SSRV_js.b,{icon:faUpload.faUpload,colorToken:"foreground-primary"}),jsxRuntime.jsxs(chunk2VCHSK65_js.d,{weight:"bold",colorToken:"foreground-primary",children:["Drag and drop or ",jsxRuntime.jsx(U,{children:"browse files"})]})]}),jsxRuntime.jsx(chunk2VCHSK65_js.d,{colorToken:"color-neutral-600",children:w})]})]})};V.displayName="UploadBox";var B={Root:T__default["default"](V)``,SvgList:G};

exports.a = B;
